import { Component, OnInit, Input, Output, ChangeDetectorRef, ViewChild, AfterViewInit, OnDestroy, SecurityContext } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { DhlFormTemplate } from '../../models/dhl-form-template';
import { FormService } from '../../services/form.service';
import { Router,ActivatedRoute } from '@angular/router';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { EventEmitter } from '@angular/core';
import { ModalService } from 'src/app/common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import { AppService } from 'src/app/app.service';
import { SnackBarComponent } from 'src/app/common/snack-bar/snack-bar.component';
import { Modal } from 'src/app/common/modal/modal';
import { Subscription } from 'rxjs';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import {TranslateService} from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import { Constant } from 'src/app/shared/constants/constants';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service'
import { Key } from 'protractor';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';


@Component({
  selector: 'app-form-comp',
  templateUrl: './form-comp.component.html',
  styleUrls: ['./form-comp.component.scss'],
  standalone: false
})
export class FormCompComponent implements OnInit {
  @Input() configData;    //DhlFormTemplate configure it properly
  @Input() parentTemplate;
  @Input() expanded: any
  @Input() newField: any

  
  @Input() orderDetails;
  @Input() searchMessage;
  @Input() searchDataLength;
  @Input() lableForConfig;
  @ViewChild('editor') editor: JsonEditorComponent;
  @ViewChild('editorTwo') editorTwo: JsonEditorComponent;
  @Input() multipleOrderDetails;
  @Output() form = new EventEmitter();
  @Output() formStatus = new EventEmitter();
  @Output() loadingStatus = new EventEmitter();
  @Output() navToIndexEmitter = new EventEmitter();

  frmGroup: UntypedFormGroup;
  isLoading: boolean = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  pageName: String;
  orderViewTemplate;
  durationInSeconds = 20;
  turnOnAction: boolean = true;

  subform: boolean = false;
  formName: String = "";
  releaseOrdercall:boolean =false;
  includeStatuscall: boolean = false;
  stepperSameRow: boolean = true;
  templatedata :any;
  bannerArrayViewList : any =  ['releaseOrder', 'orderEntry'];
  arrayOfTempName = ['releaseOrder', 'orderEntry', 'orderViewEdit', 'releaseOrderViewEdit'];
  ellipseBtn = {
    "showDrop": false
  }

  subscription: Subscription;
  totalError : any = 0;
  constant : any = Constant;
  stopTimeout$ : any;
  ArrayOfFilledFields : any = [];
  isDarftGetError : any = false;
  timeout:any;
  orderStatusValidation : any = false;
  enum=Constant;
  componentData : any;
  EditedData: string;
  jedit: any;
  editorOptions: JsonEditorOptions;
  jsonDataTest: any;
  reload: boolean = true;

  // tempData;
  // fillData(){
  //   this.frmGroup.controls.stepOne.patchValue(this.tempData.orderDetails[0].stepOne)
  //   this.frmGroup.controls.stepTwo.patchValue(this.tempData.orderDetails[1].stepTwo)
  // }

  constructor(private modalService: ModalService, private _snackBar: CustomSnackBarService, private fb: UntypedFormBuilder, private change: ChangeDetectorRef, private formService: FormService, private router: Router, private appService: AppService,private route: ActivatedRoute, public translate: TranslateService, private alphaService : AlphaService) {
    this.editorOptions = new JsonEditorOptions()
    this.editorOptions.modes = ['form','tree', 'code'];
    this.editorOptions.mode = 'form';
  }

  setFormMetadata(data) {
    this.orderViewTemplate = data;
  }

  
  changeLog(event) {
    try {
      const editorJson = this.editor.get();
      this.jedit = editorJson;
    } catch (error) {
      console.log('Change event triggred with invalid JSON.', error)
    }
  }

  showJson(d) {
    console.log("edit",d);
    this.EditedData = JSON.stringify(d, null, 2);
  }

  isEnclosed: string;
  tradeIn_isEnclosed: string;
  isOparable: string;
  tradeIn_isOparable: string;

  ngOnInit() {
   //this.frmGroup.get(this.configData.name).setValue(this.orderDetails[this.configData.name]);
    // update group message start
    let orderDtls = this.orderDetails;
    if(this.configData.hasOwnProperty("name")){
      this.formName = this.configData.name;
    }
    if(this.configData.hasOwnProperty("header") && this.configData.header.hasOwnProperty("action") && this.configData.header.action.hasOwnProperty("enable")){
      this.turnOnAction = this.configData.header.action.enable;
    }
    // update group message end

    this.formStatus.emit(this.isSubmitted);
    localStorage.setItem('lastShipCard', 'false');

    localStorage.setItem('templateName', this.configData.name);
    this.pageName = APP_Constants.SEARCH_PAGE;
    if(this.configData['schemaValidation']){
      this.frmGroup = this.formService.simpleFormCreation(this.configData);
    } else{
      this.frmGroup = this.formService.createForm(this.configData);
    }

    this.subform = this.frmGroup['subform'] || false;
    this.formService.quoteType = this.frmGroup.value.quoteType
    this.formService.quotReqToggleSet(this.frmGroup.value.quoteType);
    let obj = this.orderDetails;

    this.form.emit(this.frmGroup);
  }

  isStepperUsed(){
    return this.configData.hasOwnProperty("sections") &&
    Array.isArray(this.configData.sections) &&
    this.configData.sections.length > 0 &&
    this.configData.sections[0].hasOwnProperty("component") &&
    this.configData.sections[0].component == 'STEPPER'
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  //CP-8121 - start
  checkSectionAccess(group, index) {
    if (group.editAccess) {
      group.editAccess.forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if (row.action == 'hidden' && !this.checkFieldAccess(persona)) {
          group.visibility = false;
          return false;
        }
        if (index && this.configData.groups[index - 1].visibility === false) {//if previous section is also hidden
          this.configData.groups[index - 1].visibility;
          group.showDividerLine = false;
        }
        else {
          group.showDividerLine = true;
        }
      });
      return true;
    }
    if (index && this.configData.groups[index - 1].visibility === false) {//if previous section is also hidden
      this.configData.groups[index - 1].visibility;
      group.showDividerLine = false;
    }
    else {
      group.showDividerLine = true;
    }
    return true;
  }

  // Method to check if the logged in user is having access of mentioned persona
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  //CP-8121 - end

  ngAfterViewInit() {
    if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('details')){
      this.configData['header']['action']['details'].forEach(action => {
        action['enableAction'] = action["enableActionOnLastStep"] ? !action["enableActionOnLastStep"] : true;
      });
    }

    //persona to hide VIP from ellipse
    if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('ellipse')){
      this.configData['header']['action']['ellipse'].forEach(action => {
        action.actions.forEach(ele => {
          if (ele['dynamicVisibility']) {
            if(ele['dynamicVisibility'].action == 'hidden'){
              ele['hidden'] = !this.checkAccess(ele['dynamicVisibility'].featureName);
            }else if(ele['dynamicVisibility'].action == 'disabled'){
              if(this.checkAccess(ele['dynamicVisibility'].featureName) == false){
                ele['disabled'] = true;
              }
            }
          }
        });
      });
    }

    this.subscription = this.appService._stepperContentSubject.subscribe(res => {
      if(res && res.hasOwnProperty("stepIndex") && res.hasOwnProperty("stepperDetails")){
        if(this.configData.hasOwnProperty('header') && this.configData['header'].hasOwnProperty('action') && this.configData['header']['action'].hasOwnProperty('details')){
          this.configData["header"]["action"]["details"].forEach(action => {
            if(action.hasOwnProperty('enableActionOnLastStep') && action.enableActionOnLastStep && (res['stepIndex'] == res['stepperDetails'].length-1)) {
              action.enableAction = true;
            }
          });
        }
      }
    });
    if(!this.stepperSameRow)
      document.getElementById('dhlFormContentV2').style.marginTop = '160px';
    if((this.configData?.name == 'orderViewEdit' || this.configData?.name == 'releaseOrderViewEdit') && (this.orderDetails?.status?.toLowerCase() === 'confirmed' || this.orderDetails?.status?.toLowerCase() === 'planned')){
      this.orderStatusValidation = true;
    } else {
      this.orderStatusValidation = false;
    }
  }

  setAccordionStatus(e, toggle, index) {
    e.preventDefault();
    if (e.target.classList[0] == 'mat-expansion-panel-header-title' || e.target.parentElement.classList[0] == 'accordion-header' || e.target.classList[0] == 'accordion-header') {
      this.configData.groups[index].open = !toggle;
    }
  }

  validateAllFormFields(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl && control.errors) {
        this.totalError += 1;
        if (control.errors.required) {
          control.markAsTouched({ onlySelf: true });
          control.markAsDirty({ onlySelf: true });
        }
      }else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        control.controls.forEach(data => {
          this.validateAllFormFields(data);
        })
      }
    });
  }

  validateShipUnitCount(): boolean {
    let totalShipUnitCount = 0;
    let totalQtyRelease = 0;

    this.frmGroup.controls.shipCard['controls'].forEach(group => {
      Object.keys(group.value).forEach(control => {
        if (control === 'huCount' && group.value[control]) {
          totalShipUnitCount += parseInt(group.value[control]);
        }
      });
    }, this);
    this.frmGroup.controls.poLines['controls'].forEach(group => {
      Object.keys(group.value).forEach(control => {
        if (control === 'qtyRelease' && group.value[control]) {
          totalQtyRelease += parseInt(group.value[control]);
        }
      });
    }, this)
    if (totalShipUnitCount > totalQtyRelease) {
      let msgObj = { 'totalShipCount': "Total ship unit count can't be greater than total release quantity" }
      this.frmGroup.controls.shipCard.setErrors(msgObj);
      this.frmGroup.controls.shipCard['controls'].forEach(group => {
        group.get('huCount').setErrors(msgObj);
      }, this);
      return false;
    } else {
      this.frmGroup.controls.shipCard['controls'].forEach(group => {
        if(+group.get('huCount').value > 0) group.get('huCount').setErrors(null);
      }, this);
      return true;
    }

  }

  formError: String = '';
  isSubmitted: boolean = false;

  submitJsonForm(e) {
    this.totalError = 0;
    this.isLoading = true;
    if(this.jedit){
    this.jsonDataTest=  this.jedit;
    }
    this.componentData = this.jsonDataTest;
    if(sessionStorage.getItem("parentTemplate"))
    {
      let parentTemplate = JSON.parse(sessionStorage.getItem("parentTemplate"));
      if(this.lableForConfig=='bannerMsg')
      {
        parentTemplate.bannerDetails.bannerMessage=this.jsonDataTest
      }
        if(this.lableForConfig=='maintitle')
        {
          parentTemplate = this.jsonDataTest;

        }
        if(this.lableForConfig != undefined){
        let datagroup=this.lableForConfig.split("-")
          if (datagroup[0] == 'addField') {
            if (parentTemplate.hasOwnProperty('groups')) {
              parentTemplate.groups.forEach(group => {
                if(group.controls[0].label=== datagroup[1]){
                  group?.controls.forEach((elm) => {
                    elm.controls.push(this.jsonDataTest)
                  }) 
                }
               else if (group.label === datagroup[1]) {
                  group.controls.push(this.jsonDataTest)
                }
              })
            }
            else if (parentTemplate.hasOwnProperty('sections')) {
              parentTemplate.sections.forEach(section => {
                section.groups.forEach(grp => {
                 if(grp.controls[0].label=== datagroup[1]){
                  grp?.controls.forEach((elm) => {
                    elm.controls.push(this.jsonDataTest)
                  })                 }
                 else if (grp.label === datagroup[1]) {
                    grp.controls.push(this.jsonDataTest)
                  }
                })
              })
            }else if(parentTemplate.hasOwnProperty('searchScreen')){
              
              parentTemplate.searchScreen.controls.forEach(ctrl => {
                if (ctrl?.searchResults && ctrl?.searchResults[0].TableHeaders) {

              ctrl?.searchResults[0].TableHeaders.push(this.jsonDataTest)
                }
              })
            }
          }
        }
        if (parentTemplate.hasOwnProperty('sections')) {
          parentTemplate.sections.forEach(group => {
            group.groups.forEach(control => {
              if (control.name === this.jsonDataTest.name) {
                control = Object.assign(control, this.jsonDataTest);
              }
              if (control?.controls && control?.controls[0].formType !== 'FORM_ARRAY') {
                control.controls.forEach((elm, idx) => {
                  if (elm.name === this.jsonDataTest.name) {
                    elm = Object.assign(elm, this.jsonDataTest);
                  }
                });
              }
              else {
                if (control?.controls && control?.controls[0].formType === 'FORM_ARRAY') {
                  control?.controls[0]?.controls.forEach(elm => {
                    if (elm.name === this.jsonDataTest.name) {
                    elm = Object.assign(elm, this.jsonDataTest);
                    }
                  });
                }
              }
            });
          });
        }
        if (parentTemplate.hasOwnProperty('groups')) {
          parentTemplate.groups.forEach(group => {
            if (group.name === this.jsonDataTest.name) {
              group = Object.assign(group, this.jsonDataTest);
            }
            group.controls.forEach(control => {
              if (control?.controls && control?.formType === 'FORM_ARRAY') {
                control.controls.forEach(elm => {
                  if (elm.name === this.jsonDataTest.name) {
                    elm = Object.assign(elm, this.jsonDataTest);
                  }
                });
              }
              else if (control.name == this.jsonDataTest.name) {
                {
                  control = Object.assign(control, this.jsonDataTest);
                }
              }
            });
          });
        }
        //UI config purchase order/search order/draft order listing 
        if (parentTemplate.hasOwnProperty('searchScreen')) {

          if(this.jsonDataTest.controls){
            parentTemplate.searchScreen = Object.assign( parentTemplate.searchScreen, this.jsonDataTest);
          }

          parentTemplate.searchScreen.controls.forEach(ctrl => {
            if (ctrl?.searchResults && ctrl?.searchResults[0].TableHeaders) {
              ctrl?.searchResults[0].TableHeaders.forEach(tableData => {
                if (tableData.title == this.jsonDataTest.title) {
                  tableData = Object.assign(tableData, this.jsonDataTest);

                }
              });
            }
          })
        }
 
      localStorage.setItem("parentTemplate",JSON.stringify(parentTemplate));
      console.log("UPDATED_TEMPLATE",parentTemplate);
      this.templatedata = JSON.parse(localStorage.getItem('templatedata'));
      let url
      console.log("res---------------",this.templatedata);
      if(localStorage.getItem('filterCurrenturl')=='/selfServiceListing/selfconfigdraft')
      {
        url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
      }
         else {
          url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
        +'&listingType='+"UIListing"
    }
  
      console.log("url--------",url,parentTemplate)
      this.appService.makeHttpPostRequest(url,parentTemplate).subscribe((data) => {
        if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
         // this.normalView();
          let preferenceId = data['data'].preferenceId;
          let saveDraftMsg = `Draft created`;
          let tempdata =  JSON.parse(localStorage.getItem('templatedata'))
           if(localStorage.getItem('filterCurrenturl')=='/selfServiceListing/selfconfigdraft'){
              this.router.navigateByUrl('/selfServiceListing/'+tempdata.customer_id+ "-"+tempdata.action);
              window.location.reload()
           }else{
            this.router.navigateByUrl('selfServiceListing/selfconfigdraft');
           }

          console.log("data----------",data)
         this._snackBar.open( { message: data['message'].statusMessage, orderId: preferenceId }, { duration: this.durationInSeconds * 1000 });
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
       // this.normalView();

        let modal = new Modal({
          action: false, name: 'Updated', title: 'Update Json ', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
    }
    // create apiUrl dynamically and make api call
  
    
    // generic submission start

    if(this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent'){
      this.isLoading = false;
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        parentTemplate:this.parentTemplate,
        name: this.configData.name,
        action: 'SUBMIT',
        postData: this.jsonDataTest,
      })

      // after submitting the button if we are waiting for result on the same page then action button should be disabled
      this.frmGroup.markAsPristine();
      this.frmGroup.markAsUntouched();
    }
  }
    // generic submission end
  

  releaseOrderCall (orderData){
    this.appService.makeHttpPostRequest(APP_Constants.RELEASE_ORDER_LINK + localStorage.getItem('customerCode') + '&userId=' +
    localStorage.getItem('userName'), orderData).subscribe((data) => {
      if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
        this.formError = ''
        let times = 0;
        let transmissionStatus;
        setTimeout(() => {

          this.appService.makeHttpGetRequest(APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') + '&orderId=' +
            data['orderId'] + '&transmissionNo=' + data['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
          ).subscribe(
            data => {
              console.log(data);
              transmissionStatus = data;
              if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                this._snackBar.open( { message: transmissionStatus['message'].statusMessage, orderId: transmissionStatus['orderId'] }, { duration: this.durationInSeconds * 1000 });
                localStorage.removeItem("selectedPoLines")
                this.router.navigateByUrl('/orders');
                this.isLoading = false;
                this.normalView();
              }

            }, err => {
              this.isLoading = false;
              this.normalView();

              let modal = new Modal({
                action: false, name: 'orderStatus', title: 'Release order status', description: err.message, actionButtonText: ''
              });
              this.modalService.createModalBox(modal, err.status);
              console.log(err);
              return false;
            });

          let intervalId = setInterval(() => {
            if (
              transmissionStatus &&
              (
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
              )) {
              this.isLoading = false;
              this.normalView();
              clearInterval(intervalId);
            } else if (++times == 5 && transmissionStatus && transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.IN_PROGRESS_CODE) {
              this.isLoading = false;
              this.normalView();
              this._snackBar.open( { message: transmissionStatus['message'].statusMessage, orderId: transmissionStatus['orderId'] }, { duration: this.durationInSeconds * 1000 });
              this.router.navigateByUrl('/orders');
              localStorage.removeItem('selectedPoLines');
              clearInterval(intervalId);
            } else {
              this.appService.makeHttpGetRequest(APP_Constants.RELEASE_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') + '&orderId=' +
                data['orderId'] + '&transmissionNo=' + data['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
              ).subscribe(
                data => {
                  console.log(data);
                  transmissionStatus = data;
                  if (transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
                    transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE) {
                    this.isLoading = false;
                    this.normalView();
                    this._snackBar.open( { message: transmissionStatus['message'].statusMessage, orderId: transmissionStatus['orderId'] }, { duration: this.durationInSeconds * 1000 });
                    localStorage.removeItem('selectedPoLines');
                    this.router.navigateByUrl('/orders');
                  }
                }, err => {
                  this.isLoading = false;
                  this.normalView();

                  let modal = new Modal({
                    action: false, name: 'orderStatus', title: 'Release order status', description: err.message, actionButtonText: ''
                  });
                  this.modalService.createModalBox(modal, err.status);
                  console.log(err);
                  clearInterval(intervalId);
                  // intervalId = 0;
                });
            }
          }, 3000);
        }, 1000);
      }

      // this.isLoading = false;
      // this.normalView();
    }, (err) => {
      console.log(err);
      this.isLoading = false;
      this.normalView();
      let modal = new Modal({
        action: false, name: 'Orders', title: 'Order release', description: err.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.status);
    })
   }
  normalView() {
    document.getElementById("overlay").style.display = "none";
  }
  backFn(){
    if(this.configData.header.title.redirectUrl){
      this.router.navigateByUrl(this.configData.header.title.redirectUrl);
    }

  }
  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  formReset(name) {
    this.totalError = 0;
    let details = [];
    this.isDarftGetError = false;
    if (this.configData.header && this.configData.header.action) {
      details = this.configData.header.action.details;
    }
    let event: DhlFormControlEvent | null = this.checkEventExist(details, name);
    if (event) {
      return this.sendToSource(event, this.orderDetails);
    }

    let templatedata = this.configData;

    // localStorage.setItem('mostUsedOriginLocations', '');
    // localStorage.setItem('mostUsedDestinationLocations', '');

    if (this.configData.name == 'releaseOrder') {
      localStorage.removeItem('poSourceId');
      localStorage.removeItem('poDestId');
      // sessionStorage.removeItem('poLineIdToBeExcluded');
      localStorage.removeItem('qtyRelease');
      localStorage.setItem('releaseFormReset', 'true'); //  need to remove this
    }

    if(this.configData.name == 'rateEnquirySearch'){
      let allOptions = this.appService._components['equipment'].configData.options.slice();
      this.appService._components['equipment'].allOptions = allOptions;
      this.appService._components['equipment'].options = [];
      this.appService._components['equipment'].searcOptionCtrl.setValue(null);
      // exception columns can be fetched from template
      
      let controlsArr = this.formService.getFormControl(this.frmGroup, ["originGeoPoints", "destinationGeoPoints", "earlyPuDate", "earlyDlDate","freightClass","quantity","volume","weight"]);
     
      localStorage.setItem('originLocationAddressToSearch', '');
      localStorage.setItem('originMapUrl', '');

      localStorage.setItem('destLocationAddressToSearch', '');
      localStorage.setItem('destMapUrl', '');
      this.frmGroup.reset();
      controlsArr.forEach(Ctrl => {
      let component = this.appService._components[Ctrl.name].configData;
      this.appService._components[component.name].configData.required = false;
      this.appService._components[component.name].frmGroup.get(component.name).setErrors(null);

      let control = Ctrl.control;
      if (component.component == 'DATEPICKER') {
        // this.appService._components['earlyPuDate'].configData
          control['maxDate'] = null;
          component.validation.forEach(check => {
            let validationCheck = check.split('-');
            if(Object.values(component.defaultValue).length){
              control.setValue(new Date(component.defaultValue.value));
            }
            if (validationCheck[0] === 'before') {
              control['minDate'] = new Date(new Date().toDateString());
            }
            if (validationCheck[0] === 'after') {
              control['minDate'] = new Date(this.formService.getFormControl(this.frmGroup, [validationCheck[1]])[0].control.value);
            }
          });
        } else if (component.component == 'DROPDOWN') {
          this.configData.configs.relatedColumns.forEach(cols => {
            // if (control.value && control.value.value == cols.key) {
            cols.value.forEach(col => {
              this.appService._components[col].configData.visibility = "hidden";
              this.appService._components[col].configData.required = false;
              this.appService._components[col].frmGroup.get(col).setErrors(null);
              this.appService._components[col].frmGroup.get(col).updateValueAndValidity();
            });
            // }
          });
        }
      }, this);
      return
    }
    if (name === 'discard') {

      this.frmGroup = this.formService.createOrderFormToViewAndEdit(this.frmGroup, this.configData, this.orderDetails);

      this.frmGroup.patchValue(this.orderDetails.value);
      setTimeout(()=>{
        // this.frmGroup.patchValue(this.orderDetails.value);
      }, 200)
      if (templatedata && templatedata.groups) {
      templatedata.groups.forEach(group => {
        group.controls.forEach((data, index) => {
          if (Array.isArray(data.controls) && data.controls.length) {
            var name = data.name;
            var component = data.component;
            if (this.frmGroup.get(name)['controls'].length && component === 'CARD') {
              this.frmGroup.get(name)['shipmentList'] = this.frmGroup.get(name).value;
            }

            if (this.frmGroup.get(name)['controls'].length) {

              data.controls.forEach((field, ind) => {
                if (field.component == 'DATEPICKER') {

                  this.frmGroup.get(name)['controls'][index].get(field.name).reset();
                  this.frmGroup.get(name)['controls'][index].get(field.name)['maxDate'] = null;

                  if (this.frmGroup.get(name)['controls'][index].get(field.name) != '')
                    this.frmGroup.get(name)['controls'][index].get(field.name).setValue(new Date(this.orderDetails.value[field.name]));

                  // if(+ new Date(this.frmGroup.get(name)['controls'][index].get(field.name).value) > +new Date(new Date().toDateString())){
                  field.validation.forEach(check => {
                    let validationCheck = check.split('-');
                    if (validationCheck[0] === 'before') {
                      this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                    }
                    if (validationCheck[0] === 'after') {
                      this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(this.frmGroup.get(name)['controls'][index].get(validationCheck[1]).value);
                    }
                  })
                  // } else{
                  // this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                  // }
                }else if(field.component == 'DROPDOWN_DEFAULT_V2'){
                  let value = this.frmGroup.get(name).value.value || this.frmGroup.get(name).value;
                  this.appService._components[field.name].selectedOption(value, true);
                }
                else if (field.component == 'TOGGLESWITCH_V2') {
                  if(this.appService._components[field.name]){
                    this.appService._components[field.name].onReset();
                  }
                }
              }, this)
            }

          } else {
            if (data.component == 'DATEPICKER') {
              this.frmGroup.get(data.name)['maxDate'] = null;

              // if(+ new Date(this.frmGroup.get(data.name).value) > +new Date(new Date().toDateString())){
              data.validation.forEach(check => {
                let validationCheck = check.split('-');
                if (validationCheck[0] === 'before') {
                  this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
                }
                if (validationCheck[0] === 'after') {
                  this.frmGroup.get(data.name)['minDate'] = new Date(this.frmGroup.get(validationCheck[1]).value);
                }
              })
              // } else{
              //   this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
              // }
              if (this.orderDetails.value[data.name] != '')
                this.frmGroup.get(data.name).setValue(new Date(this.orderDetails.value[data.name]));
            }else if(data.component == 'DROPDOWN_DEFAULT_V2'){
              let value = this.frmGroup.get(data.name).value.value || this.frmGroup.get(data.name).value;
              this.appService._components[data.name].selectedOption(value, true);
            }else if (data.component == 'TOGGLESWITCH_V2') {
              if(this.appService._components[data.name]){
                this.appService._components[data.name].onReset();
              }
            }
          }
        }, this)
      }, this);
      if(!this.orderDetails.skipSecondary || this.orderDetails.skipSecondary === undefined){
        this.formService.setSecondaryTextFormField(this.orderDetails, this.frmGroup);
      }

      this.frmGroup.markAsPristine();
      this.frmGroup.markAsUntouched();

      return;
    }
    }

    localStorage.setItem('originLocationAddressToSearch', '');
    localStorage.setItem('originMapUrl', '');

    localStorage.setItem('destLocationAddressToSearch', '');
    localStorage.setItem('destMapUrl', '');
    this.frmGroup.reset();

    if (templatedata) {
      if (templatedata['sections']) {
        if (Array.isArray(templatedata['sections']) && templatedata['sections'].length) {
          templatedata['sections'].forEach((element, j) => {

          console.log(this.frmGroup)
          element.groups.forEach((group, i) => {

          group.controls.forEach((elem, index) => {
            console.log(elem);
            if (elem.component == 'DROPDOWN_DEFAULT_V2') {
              this.appService._components[`${elem.name}`].reset();
              if(this.appService._components[`${elem.name}`]){
                const defaultValueObj = this.appService._components[`${elem.name}`].configData.defaultValue;
                const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                this.appService._components[`${elem.name}`].selectedOption(defVal, true);
              }
            }

            else if (elem.component == 'DATEPICKER_V2') {
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name].reset();
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name]['maxDate'] = null;
              this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name]['minDate'] = new Date(new Date().toDateString());
              if (elem.defaultValue) {
                const defaultDate = (elem.defaultValue && typeof elem.defaultValue === 'object' && elem.defaultValue.displayValue) ? elem.defaultValue.displayValue : elem.defaultValue;
                this.frmGroup['controls'][element.name]['controls'][0]['controls'][elem.name].setValue(new Date(defaultDate));
              }else if (elem.component == 'TOGGLESWITCH_V2') {
                if(this.appService._components[elem.name]){
                  this.appService._components[elem.name].onReset();
                }
              }
            }
            else if(elem.component == 'TABLE_V2'){
              elem.controls.forEach(elements => {
                if (elements.component == 'DROPDOWN_DEFAULT_V2'){
                  this.appService._components[`${elements.name}`].reset();
              if(this.appService._components[`${elements.name}`]){
                const defaultValueObj = this.appService._components[`${elements.name}`].configData.defaultValue;
                const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                this.appService._components[`${elements.name}`].selectedOption(defVal, true);
              }
                }
                
              });
            }
            
            });
          }, this);
          });
        }
      }
      else {
      templatedata.groups.forEach(group => {
        group.controls.forEach((data, index) => {
          if (Array.isArray(data.controls) && data.controls.length) {
            var name = data.name;
            if (data.validation) {
              data.validation.forEach(check => {
                if (check == 'ZeroOrMoreLines') {
                  this.frmGroup.get(data.name)['controls'].splice(1, this.frmGroup.get(data.name)['controls'].length);
                  this.frmGroup.get(data.name).reset();
                } else if (check == 'OneOrMoreLines') {
                  this.frmGroup.get(data.name).reset();

                  Object.keys(this.frmGroup.get(data.name)['controls'][0]['controls']).forEach( element => {
                    if(this.appService._components[element]?.configData?.component == "DROPDOWN_DEFAULT_V2"){
                      this.appService._components[element].reset()
                    }
                  })

                  this.frmGroup.get(data.name)['controls'].splice(0, this.frmGroup.get(data.name)['controls'].length - 1);
                  this.frmGroup.get(data.name)['controls']['deleteButton'] = false;

                  this.frmGroup.get(data.name)['controls'][0]['secondaryText'] = '';
                  this.frmGroup.get(data.name)['controls'][0]['itemArray'] = [];
                  this.frmGroup.get(data.name)['shipmentList'] = [];
                }
                else {
                  if (this.frmGroup.get(name)['controls'].length) {
                    data.controls.forEach((field, ind) => {
                      if (!Object.keys(field.defaultValue).length) {
                        this.frmGroup.get(name)['controls'][index].get(field.name).reset();

                      } else {
                        if (data.component == 'DATEPICKER') {
                          this.frmGroup.get(name)['controls'][index].get(field.name).reset();
                          this.frmGroup.get(name)['controls'][index].get(field.name)['maxDate'] = null;
                          this.frmGroup.get(name)['controls'][index].get(field.name)['minDate'] = new Date(new Date().toDateString());
                          this.frmGroup.get(name)['controls'][index].get(field.name).setValue(new Date(data.defaultValue.displayValue));
                        } else {
                          this.frmGroup.get(name)['controls'][index].get(field.name).setValue(data.defaultValue);
                        }
                      }
                    }, this)
                  }
                }
              }, this)
            }
          }
          else {
            if (!Object.keys(data.defaultValue).length) {
              this.frmGroup.get(data.name).reset();
              this.frmGroup.get(data.name)['secondaryText'] = '';
              this.frmGroup.get(data.name)['locationArray'] = [];
              this.appService.newEvent({ 'location': 'reset' });

              //CP-4363 RESET Autocomplete 'ItemArray' value with blank array/default value.
              if (data.component === "GENERIC_AUTOCOMPLETE_V2"){
                let defVal =  data.defaultValue[0] || data.defaultValue;
                this.frmGroup.get(data.name).setValue(defVal);
                if(defVal){
                  this.frmGroup.get(data.name)['itemArray'].push(defVal);
                } else {
                  this.frmGroup.get(data.name)['itemArray'] = [];
                }
              }
            }
            else {
              if (data.component == 'DATEPICKER') {
                this.frmGroup.get(data.name).reset();
                this.frmGroup.get(data.name)['maxDate'] = null;
                this.frmGroup.get(data.name)['minDate'] = new Date(new Date().toDateString());
                this.frmGroup.get(data.name).setValue(new Date(data.defaultValue.displayValue));
              }
              else if (data.component == 'DROPDOWN_DEFAULT_V2') {
                this.frmGroup.get(data.name).reset();
                if(this.appService._components[data.name]){
                  const defaultValueObj = this.appService._components[data.name].configData.defaultValue;
                  const defVal = (defaultValueObj && typeof defaultValueObj === 'object' && 'value' in defaultValueObj) ? defaultValueObj.value : defaultValueObj;
                  this.appService._components[data.name].selectedOption(defVal, true);
                }
                this.appService._components[data.name].reset();
              }
              else if (data.component == 'TOGGLESWITCH_V2') {
                if(this.appService._components[data.name]){
                  this.appService._components[data.name].onReset();
                }
              }
              else if (data.component == 'RADIOBUTTON_V2') {
                if(this.appService._components[data.name]){
                  this.appService._components[data.name].onReset();
                }
              }
              else {
                this.frmGroup.get(data.name).setValue(data.defaultValue);
              }
            }
            // Default show/hide value assign to warning message component
            if (data.warningText) {
              data.warningText.showText = data.warningText.showDefaultText;
            }
          }
        }, this)
      }, this);
    }
    }
    // discard functionality for order update

    if(name && name.type === "discard"){
      let obj = this.orderDetails;
      this.totalError = 0;
      if (obj !== undefined && obj !== null && obj.value !== undefined && obj.value !== null) {
            this.frmGroup.patchValue(obj.value);
          if(obj.validateField){
            this.validateAllFormFields(this.frmGroup);
          }
      }
       // this.form.emit(this.frmGroup);
    }

    //CP-2434 :start : date format changes on discard or reset---fixed
    if (this.configData.sections) {
      this.configData.sections.forEach((section, i) => {
        section.groups.forEach((groups, j) => {
          groups.controls.forEach((control, k) => {
            if (control.component == "DATEPICKER_V2" && control.dataType == 'OBJECT' && this.frmGroup.get(section.name)['controls'][0].get(control.name).value
              && typeof this.frmGroup.get(section.name)['controls'][0].get(control.name).value == 'string') {
              let obj = {};
              try {
                let val = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
                obj['displayValue'] = this.appService.getSystemDateMMddyyyy(val);

                if(val.length >10){
                  obj['value'] = val;
                }
                else{
                  obj['value'] = new Date(this.appService.formatDateForExportDatepicker(val)).toISOString().slice(0, -1);
                }
              }
              catch (e) {
                obj['displayValue'] = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
                obj['value'] = this.frmGroup.get(section.name)['controls'][0].get(control.name).value;
              }
              this.frmGroup.get(section.name)['controls'][0].get(control.name).setValue(obj);
            }
            this.formResetAndSetVal(control);
          });
        });
      });
    }
    else {
      this.configData.groups.forEach((groups, j) => {
        groups.controls.forEach((control, k) => {
          if (control.component == "DATEPICKER_V2" && control.dataType == 'OBJECT' && this.frmGroup.get(control.name).value
            && typeof this.frmGroup.get(control.name).value == 'string') {
            let obj = {};
            try {
              let val = this.frmGroup.get(control.name).value;
              obj['displayValue'] = this.appService.getSystemDateMMddyyyy(val);

              if(val.length >10){
                obj['value'] = val;
              }
              else{
                obj['value'] = new Date(this.appService.formatDateForExportDatepicker(val)).toISOString().slice(0, -1);
              }
            }
            catch (e) {
              obj['displayValue'] = this.frmGroup.get(control.name).value;
              obj['value'] = this.frmGroup.get(control.name).value;
            }
            this.frmGroup.get(control.name).setValue(obj);
          }
          this.formResetAndSetVal(control);
        });
      });
    }//CP:2434 : end

    // =================== GENERIC RESET START =====================================

    if (this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent') {

      if(this.configData.schemaValidation){
        // ------------- START OF RESET FOR NEW SCHEMA VALIDATED TEMPLATES -------------------------
        this.frmGroup.reset();
        this.setValueForAnyTemplate();
        this.appService._commonComponentSubject.next({
          configData: this.configData,
          name: this.configData.name,
          action: 'RESET'
        })
        // ------------- END OF RESET FOR NEW SCHEMA VALIDATED TEMPLATES -------------------------
      } else {
        let that = this;
        if (this.configData.sections) {
          this.configData.sections.forEach((a, i) => {
            a.groups.forEach((b, j) => {
              b.controls.forEach((c, k) => {
                if (c.defaultValue && c.defaultValue !== undefined) {
                  if (!(Object.keys(c.defaultValue).length === 0 && c.defaultValue.constructor === Object) && c.defaultValue) {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name).setValue(c.defaultValue);
                  }
                }
                //RESET Autocomplete 'ItemArray' value with default value to remove error "Please Select from list".
                if (c.component === 'GENERIC_AUTOCOMPLETE_V2') {
                  let defVal = c.defaultValue[0] || c.defaultValue;
                  this.frmGroup.get(a.name)['controls'][0].get(c.name).setValue(defVal);
                  if (defVal) {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name)['itemArray'].push(defVal);
                  } else {
                    that.frmGroup.get(a.name)['controls'][0].get(c.name)['itemArray'] = [];
                  }
                }
              })
            })
          })
        }

        let obj = this.orderDetails;
        if (obj !== undefined && obj !== null && obj.value !== undefined && obj.value !== null ) {
          this.frmGroup.patchValue(obj.value);
          if (obj.validateField) {
            this.validateAllFormFields(this.frmGroup);
          }
        }

        // discard functionality for order verify
        if (name === 'orderReset') {
          let obj = this.multipleOrderDetails;
          if (obj && obj !== undefined) {
            this.frmGroup.patchValue(this.multipleOrderDetails);
            if (obj.validateField) {
              this.validateAllFormFields(this.frmGroup);
            }
          }
        }

        this.appService._commonComponentSubject.next({
          configData: this.configData,
          name: this.configData.name,
          action: 'RESET'
        })
      }


    }
    // =================== GENERIC RESET END =====================================
  }

  setValueForAnyTemplate(){
    let groupControls = [];
        if(this.configData.sections){
          this.configData.sections.forEach((section, sectionIndex)=>{
            section.groups.forEach((group, groupIndex)=>{
              group.controls.forEach((control, controlIndex)=>{
                groupControls.push({'control': control, 'section': section.name});
              });
            });
          });
        } else if(this.configData.groups){
          this.configData.groups.forEach((group, groupIndex)=>{
            group.controls.forEach((control, controlIndex)=>{
              groupControls.push({'control': control, 'section': null});
            });
          });
        }
        if(groupControls.length){
          groupControls.forEach((controlData, controlIndex)=>{
            if(controlData.control.defaultValue){
              let value = (this.orderDetails && this.orderDetails?.rawData) ? this.orderDetails.rawData[controlData.control.name] : null;
              if((value === undefined || value === null) && controlData?.control?.formType !== 'FORM_ARRAY'){
                value = this.formService.fetchValueFromDefaultValue(controlData.control);
              }
              let frmControl;
              if(controlData.section){
                frmControl = this.frmGroup.get(controlData.section)['controls'][0].get(controlData.control.name);
              } else{
                frmControl = this.frmGroup.get(controlData.control.name);
              } 

              if (controlData.control.formType === 'FORM_ARRAY') {
                if (value === undefined || value === null) {
                  frmControl.controls.splice(0,frmControl.controls.length);
                  frmControl.controls.deleteButton = false;
                  let tempForm = this.formService.simpleFormCreation(controlData.control);
                  (<UntypedFormArray>frmControl).push(tempForm.controls[0]);
                  controlData.control.controls.forEach((innerCtrl) => {
                    for (let i = 0; i < frmControl['controls'].length; i++) {
                      const innerFormGrp = frmControl['controls'][i].get(innerCtrl.name);
                      if (innerFormGrp && !(innerFormGrp instanceof UntypedFormArray)) {
                        innerFormGrp.patchValue(this.formService.fetchValueFromDefaultValue(innerCtrl));
                      }
                    }
                  });
                } else {
                  let length;
                  if(value.length > frmControl.controls.length){
                    length = value.length - frmControl.controls.length;
                    for (let i = 0; i < length; i++) {
                      let tempForm = this.formService.simpleFormCreation(controlData.control);
                      (<UntypedFormArray>frmControl).push(tempForm.controls[0]);
                    }
                  } else {
                    length = frmControl.controls.length - value.length;
                    for (let i = 0; i < length; i++) {
                      frmControl.controls.pop();
                    }
                  }
                  frmControl.controls.deleteButton = true;
                  frmControl.patchValue(value);

                  if(controlData.control.controls){
                    controlData.control.controls.forEach((innerCtrl) => {
                      const innerFormGrp = frmControl['controls'][0] ? frmControl['controls'][0].get(innerCtrl.name) : null;
                      if (innerCtrl.component == "ORDER_ITEM_AUTOCOMPLETE_V2" && (innerFormGrp.value! == null || innerFormGrp.value !== undefined)) {
                        innerFormGrp['itemArray'].push(innerFormGrp.value);
                      }
                      if (innerCtrl.component === "CHIPSAUTOCOMPLETE") {
                        this.appService._components[innerCtrl?.name].setDefaultValueOnReset();
                      }
                      if (innerCtrl.component === "PO_ITEM_AUTOCOMPLETE_V2" && !innerFormGrp['itemArray'].includes(innerFormGrp.value)) {
                        innerFormGrp['itemArray'].push(innerFormGrp.value);
                      }
                    })
                  }

                  if (controlData.control.name === 'poLines' && frmControl?.controls[0]["secondaryText"] === "" && this.orderDetails?.rawData?.poLines) {
                    let poLineSecondaryText = {}, 
                    data = this.orderDetails.rawData.poLines[0];
                    poLineSecondaryText["source"] = data['shipFromId'] + ',' + data['shipFromName'] || '';
                    poLineSecondaryText["destination"] = data['shipToId'] + ',' + data['shipToName'] || '';
                    poLineSecondaryText["seperator"] = 'arrow_right_alt';
                    frmControl.controls[0]["secondaryText"] = poLineSecondaryText;
                  }
                }    
              } else {
                frmControl.patchValue(value);
              }

              // if (controlData.control.formType === 'FORM_ARRAY') {
              //   controlData.control.controls.forEach((innerCtrl) => {
              //     const innerFormGrp = frmControl['controls'][0].get(innerCtrl.name);
              //     if (innerFormGrp && !(innerFormGrp instanceof FormArray)) {
              //       let innerValue = this.orderDetails?.rawData[controlData.control.name] || null;
              //       if(innerValue === undefined || innerValue === null){
              //         innerValue = this.formService.fetchValueFromDefaultValue(innerCtrl);
              //       }
              //       innerFormGrp.patchValue(innerValue);
              //     }
              //   });
              // } else {
              //  frmControl.patchValue(value);
              // }
              //--------RESET Autocomplete 'ItemArray' value with default value to remove error "Please Select from list".
              if (controlData.control.component === 'GENERIC_AUTOCOMPLETE_V2') {
                if(value === null || value === undefined){
                  frmControl['itemArray'] = [];
                } else {
                  frmControl['itemArray'].push(value);  
                }
              } 
              //Portalna-8499 observation Reset Issue for Premium freight Toggle fixed
              if (controlData.control.component === 'GENERIC_FIELD_V2') {
                if(value === null || value === undefined){
                  frmControl['value'] = "";
                } else if (value !== "" ) {
                  frmControl['value'] = value; 
                frmControl['hidden'] = false; 
                }
              } 
              // --------RESET Autocomplete

              // Attribute 'dynamicDefaultValue' To use dynamic defalut value for calendar. for e.g. set default value as date+10
              if (controlData.control.component === 'DATEPICKER_V2' && controlData.control.dynamicDefaultValue) {
                let currentDate = new Date();
                let result = currentDate.setDate(currentDate.getDate() + parseInt(controlData.control.dynamicDefaultValue.split("+")[1]));        
                let date_value = this.orderDetails ? this.orderDetails.rawData[controlData.control.name] : null;
                if(date_value === undefined || date_value === null){
                  frmControl.patchValue(this.appService.formatDateValueForCox(controlData.control, new Date(result).toISOString().slice(0, -1)));
                } else {
                  frmControl.patchValue(this.appService.formatDateValueForCox(controlData.control, date_value));
                }              
              } // END - dynamicDefaultValue 
              
              if(controlData.control.component === 'LOCATION_AUTOCOMPLETE_V2') {
                let data = this.orderDetails;
                if(frmControl['secondaryText'] === "" && (controlData.control.type === "SOURCE" || controlData.control.type === "ORIGIN") && data)
                  frmControl['secondaryText'] = data?.sourceLocationAddressLine + "," + data?.sourceLocationCity + ',' + data?.sourceLocationProvinceCode + ',' + data?.sourceLocationPostalCode;
                else if(frmControl['secondaryText'] === "" && controlData.control.type === "DESTINATION" && data)
                  frmControl['secondaryText'] = data?.destinationLocationAddressLine + "," + data?.destinationLocationCity + ',' + data?.destinationLocationProvinceCode + ',' + data?.destinationLocationPostalCode;
                  
                if(frmControl.value && !frmControl['itemArray'].includes(frmControl.value)) 
                  frmControl['itemArray'].push(frmControl.value);

                if (!frmControl?.hidden && controlData?.control?.events?.length > 0) {
                  if (!value) {
                    this.appService.setDestinationUsedLocation('');
                    this.appService.setOriginUsedLocation('');
                    this.appService._components[controlData.control.name]?.onCommonEventHander('VALIDATE_WHEN_AUTOCOMPLETE_SELECTED', null);
                  } else {
                    this.alphaService.setLocationDraftOrder(data);
                    this.appService._components[controlData.control.name]?.setDefaultValueOnReset();
                  }
                }   
              }

              if (controlData?.control?.component === 'DROPDOWN_SIMPLE_V2' && !value && !frmControl?.hidden && controlData?.control?.events?.length > 0) {
                this.appService._components[controlData.control?.name]?.onCommonEventHander('SELECTED_VALUE', null);
              }

              if (controlData?.control?.component === 'DROPDOWN_SIMPLE_V2' && !value && !frmControl?.hidden && controlData?.control?.events?.length > 0) {
                this.appService._components[controlData.control?.name]?.onCommonEventHander('SELECTED_VALUE', null);
              }
            }
          });
        }
  }
  //Reset some fields for dynamic validationn
  formResetAndSetVal = (control) => {
    if (control && control.controls) {
      const itemControls = <UntypedFormArray>this.frmGroup.get(control.name);
      const itemFormGroup = itemControls && <UntypedFormGroup>itemControls.controls[0];
      itemFormGroup && control.controls.forEach(elm => {
        if (elm.groupValidation) {
          const formGroupData = itemFormGroup.get(elm.name);
          formGroupData['isRequired'] = false; // this key is use for '*' mark show/hide
          formGroupData.setValidators([Validators.required]);
          formGroupData.updateValueAndValidity();
          formGroupData.reset();
        }
      });
    }
    else {
      if (control.groupValidation) {
        const formGroupData = this.frmGroup.get(control.name);
        formGroupData['isRequired'] = false; // this key is use for '*' mark show/hide
        formGroupData.setValidators([Validators.required]);
        formGroupData.updateValueAndValidity();
        formGroupData.reset();
      }
    }
  }

  addNewFeatures(formGroup, features) {
    features.forEach(feature => {
      if (feature.type === 'storage') {
        let storage = feature.storageDetails;
        let databaseStorage = feature.database;
        let value = [];
        if (storage) {
          storage.forEach(element => {
            let list = JSON.parse(localStorage.getItem(element.field.name));
            if (element.field.formField === 'origin') {
              let location = this.appService.getOriginUsedLocation();
              let present = false;
              if (list && location) {
                list.forEach(a => {
                  if (a.locationId === location.locationId) {
                    present = true;
                  }
                })
                if (!present) {
                  list.push(location);
                }
                value = list;
              } else {
                value.push(this.appService.getOriginUsedLocation());
              }
              let url = APP_Constants.USER_PREFERENCE_URL + localStorage.getItem('userName') + '&customerCode=' +
                localStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + feature.action;

              this.appService.makeHttpPostRequest(url, value).subscribe(data => {
                console.log(data);
              }, err => {
                console.log(err);
              });
            }
            if (element.field.formField === 'destination') {
              let location = this.appService.getDestinationUsedLocation();
              let present = false;
              if (list && location) {
                list.forEach(a => {
                  if (a.locationId === location.locationId) {
                    present = true;
                  }
                })
                if (!present) {
                  list.push(location);
                }
                value = list;
              } else {
                value.push(this.appService.getDestinationUsedLocation());
              }
              let url = APP_Constants.USER_PREFERENCE_URL + localStorage.getItem('userName') + '&customerCode=' +
                localStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + feature.action;

              this.appService.makeHttpPostRequest(url, value).subscribe(data => {
                console.log(data);
              }, err => {
                console.log(err);
              });
            }
            if (element.field.type === 'LOCALSTORAGE') {
              localStorage.setItem(element.field.name, JSON.stringify(value));
            } else if (element.type === 'SESSIONSTORAGE') {
              localStorage.setItem(element.field.name, JSON.stringify(value));
            }
            value = [];
          });
        }

        // if (databaseStorage) {
        //   databaseStorage.forEach(element=>{
        //     if (element.field.formField === 'destination') {
        //       let url = APP_Constants.USER_PREFERENCE_URL + sessionStorage.getItem('userName') + '&customerCode=' +
        //       sessionStorage.getItem('customerCode') + '&preferenceType=' + element.field.preferenceType + '&action=' + element.field.action;

        //       this.appService.makeHttpPostRequest(APP_Constants.USER_PREFERENCE_URL,{}).subscribe(data=>{
        //         console.log(data);
        //       }, err=>{
        //         console.log(err);
        //       });
        //     }
        //   })
        // }
      }
    })
  }

  makeApiCall(postUrl, transmissionUrl, redirectUrl, orderData, method, modalDetails) {
    let postData;

    if (method === 'UPLOAD') {
      postData = orderData.param;
      const formData: FormData = new FormData();
      let fileData = this.appService.getUploadFileData()
      if (fileData)
        formData.append('file', fileData, fileData.name);
      formData.append('requestData', JSON.stringify(postData));
      postData = formData;
    } else {
      postData = orderData
    }


    this.appService.makeHttpPostRequest(postUrl, postData).subscribe(response => {
      if (modalDetails.name === 'customer') {
        this.isLoading = false;
        this.normalView();
        // this.appService.
        this._snackBar.open( { message: 'Customer onboarded !', orderId: '' }, { duration: this.durationInSeconds * 1000 });
        this.router.navigateByUrl('/profile');
        this.router.navigateByUrl('/cutomer/status');
      } else {
        let rateEnquiry = { ...postData.param }
        // rateEnquiryResult = postData.param;
        rateEnquiry['mode'] = this.frmGroup.value.mode;
        rateEnquiry['equipment'] = this.frmGroup.value.equipment;

        console.log(response);
        this.isLoading = false;
        this.normalView();

        this.appService.setRateLookupResult(response);

        if (redirectUrl !== null && redirectUrl !== "") {
          console.log(JSON.stringify(rateEnquiry));
          this.appService.setRateLookupEnquiry(rateEnquiry);
          this.router.navigateByUrl(redirectUrl);
        }
        // if (response['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          // this.appService.setRateLookupResult(response);
        // } else {
        //   this.appService.setRateLookupResult(response);
        //   console.log(response['data'].transmissionNumber);
        // }
      }
    }, err => {
      this.isLoading = false;
      this.normalView();

      let modal = new Modal({
        action: false, name: modalDetails['name'], title: modalDetails['title'], description: err.message, actionButtonText: ''
      });
      this.modalService.createModalBox(modal, err.status);
    });

  }

  redirectTo(name){
    this.navToIndexEmitter.emit(name);
    // else{
    //   this._snackBar.openFromComponent(SnackBarComponent, { duration: 2000, data: { orderId: '', message: 'Invalid redirect url. Failed to redierct to \''+ redirectUrl + '\'.'} });
    // }
  }

  toggleActionDrop(){
    this.ellipseBtn.showDrop = !this.ellipseBtn.showDrop;
  }

  ellipseAction(action){
    let data;
    if(this.orderDetails.value['stepOne']){
     data = this.orderDetails.value['stepOne'][0];
    }else {
      data = this.orderDetails.value;
    }

    let eventData: any = {
      action: action.type,
      name: this.configData.name,
      component: this,
      configData: action,
      data: data
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  //BOL download function view
  bolDownloadFile = () => {
    let orderId = this.route.snapshot.params.id;
    this.isLoading = true;
    document.getElementById("overlay").style.display = "block";
    let downloadAPI = `${APP_Constants.BOL_DOWNLOAD_FILE}VIEW_SCORE_EDOC_DOC&orderId=${orderId}&customerCode=${localStorage.getItem('customerCode')}&userId=${localStorage.getItem('userName')}`;
    this.appService.makeHttpDocRequest(downloadAPI).subscribe({
      next: (data: any) => {
        let fileName = "BOL_Data_";
        fileName += this.appService.getCurrentDateAndTime() + ".pdf";
        let file = new Blob([data], { type: 'application/json' });
        try {
          console.log(data.text() == undefined);
          data.text().then(value => { //convert blob to Json again and check the message.
            let objData = JSON.parse(value)
            if (objData["message"]["statusCode"] == "ERROR") {
              let modal = new Modal({
                action: false, name: 'orderCancelInvalid', title: 'Download File', description: objData["message"]['statusMessage'], actionButtonText: ''
              });
              this.modalService.createModalBox(modal, 'ERROR');
            } else {
              FileSaver.saveAs(data, fileName);//Download here because data is coming in PDF format 
            }
          }).catch(error => {
            FileSaver.saveAs(data, fileName); //Download here because data is coming in PDF format 
          });
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }
        this.normalView();
        this.isLoading = false;
      },
      error: (err) => {
        this.normalView();
        this.isLoading = false;
        try {
          err.error.text().then(value => {
            let objData = JSON.parse(value)
            const message = objData['message']['statusMessage'];
            console.log(message, "****BOL Download Error****")
            let modal = new Modal({
              action: false, name: 'orderCancelInvalid', title: 'Download File', description: message, actionButtonText: ''
            });
            this.modalService.createModalBox(modal, 'ERROR');
          })
        }
        catch (error) {
          console.log(error, "***Connect with TOP BE team***");
        }

      }
    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }

  //START: CP-3525 - Ability to save the order/s during the verification process
  saveForm(event, command,name) {
    // if(this.configData.header && this.configData.header.action && this.configData.header.action.handler === 'parent'){
      // this.isLoading = false;
    if(this.frmGroup.invalid) {
      return false;
    } else {
      this.appService._commonComponentSubject.next({
        configData: this.configData,
        name: this.configData.name,
        action : 'SUBMIT',
        postData: this.formService.formatOrderObject(this.frmGroup.controls),
        command: command
      })
    }
    // }
  }

   // CP-5734 check banner is open or closed
  getBannerDetail(){
    if((document.getElementById("bannerId") && document.getElementById("bannerId").style.display === 'block')){
      if(document.getElementById("genericErrorMessageID")){
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }


}
